import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ConfirmationDialogComponent} from './confirmation-dialog.component';
import {ConfirmationDialogService} from './confirmation-dialog.service';
import {MaterialModule} from '../../common-modules/material.module';
import {TranslateModule} from '@ngx-translate/core';


@NgModule({
  declarations: [ConfirmationDialogComponent],
  imports: [
    CommonModule,
    MaterialModule,
    TranslateModule
  ],
  providers: [
    ConfirmationDialogService
  ]
})
export class ConfirmationDialogModule { }
